import { render, staticRenderFns } from "./WidgetField.vue?vue&type=template&id=521871c8&"
import script from "./WidgetField.vue?vue&type=script&lang=js&"
export * from "./WidgetField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports